<template>
  <div class='InputCrono'>
    <div class="datepicker date1">
      <div class="label">A partir de</div>
      <VueDatePicker
      :enable-time-picker="false"
      teleport-center
      locale="pt-br"
      select-text="Selecionar"
      cancel-text="Cancelar"
      @update:model-value="newValue => ChangeProdEdit({ dateOfertaStart: dateFormat(newValue, 'dd-mm-yyyy') })">
        <template #trigger>
          <input :value="SelectedProdEdit.dateOfertaStart === '01-01-1900' ? '' : SelectedProdEdit.dateOfertaStart" class="date-select">
        </template>
      </VueDatePicker>
    </div>
    <div class="datepicker date2">
      <div class="label">Até</div>
      <VueDatePicker
      :enable-time-picker="false"
      teleport-center
      locale="pt-br"
      select-text="Selecionar"
      cancel-text="Cancelar"
      @update:model-value="newValue => ChangeProdEdit({ dateOfertaEnd: dateFormat(newValue, 'dd-mm-yyyy') })">
        <template #trigger>
          <input :value="SelectedProdEdit.dateOfertaEnd === '01-01-1900' ? '' : SelectedProdEdit.dateOfertaEnd" class="date-select">
        </template>
      </VueDatePicker>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import dateFormat from 'dateformat'
export default {
  name: 'InputCrono',
  components: { VueDatePicker },
  computed: {
    ...mapGetters(['SelectedProdEdit'])
  },
  data () {
    return {
      date1: null,
      date2: null,
      dateFormat: dateFormat
    }
  },
  methods: {
    ...mapActions(['ChangeProdEdit']),
    handleDate1 (modelValue) {
      this.date1 = modelValue
    },
    handleDate2 (modelValue) {
      this.date2 = modelValue
    }
  }
}
</script>

<style scoped>
.InputCrono {
  width: 100%;
  display: flex;
  align-items: center;
}

.datepicker {
  width: 50%;
  padding: 1%;
}

.date1 {
  padding-left: 0;
}

.label {
  width: 50%;
  text-align: left;
  font-size: 12px;
  padding-left: 3px;
  margin-bottom: 5px;
}

.date-select {
  width: 95.5%;
  padding: 2.4%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  font-size: 18px;
}
</style>
